import Button from '../../Button';
import styles from './MessageContainer.module.css';
import { ReactComponent as GithubIcon } from "../../../assets/images/github-logo.svg";
import { ReactComponent as ArrorIcon } from "../../../assets/images/arrow-right-up-square.svg";
import { openGithubPermissions } from '../../../utils/githubPopup';
import { AmplitudeEvent, trackEvent } from '../../../utils/amplitude';

export interface MessageContainerProps {
  msgTitle: string;
  primaryIcon?: React.ReactNode;
  msgDesc?: string;
  showButton?: Boolean,
  buttonText?: string,
  buttonAction?: 'EDIT' | 'IMPORT';
  extra?: React.ReactNode
  /**
   * `stack` centres everything in a column — right for the empty and error
   * states, which own the whole panel and have nothing above them.
   *
   * `row` puts the sentence and the button on one line, for the footer that
   * sits under a list of results. There the centred column read as a second
   * empty state announcing itself below rows that had loaded perfectly well.
   */
  layout?: 'stack' | 'row'
}

const MessageContainer = ({msgTitle, primaryIcon, msgDesc = '', showButton = false, buttonText = '', buttonAction, extra, layout = 'stack' }: MessageContainerProps) => {
  const onButtonClick = () => {
    if (buttonAction === 'EDIT')  trackEvent(AmplitudeEvent.EDIT_GITHUB_PERMISSION_CLICK);
    if (buttonAction === 'IMPORT') trackEvent(AmplitudeEvent.IMPORT_GITHUB_REPOSITORY_CLICK);
    openGithubPermissions();
  }

  if (layout === 'row') {
    return (
      <div className="flex items-center gap-5 px-[1.875rem] py-6 [@media(max-width:639.98px)]:flex-col [@media(max-width:639.98px)]:items-stretch">
        <span className="flex-1 text-[0.875rem] leading-140 text-text-dim">
          {msgDesc}
        </span>
        {showButton && (
          <Button type="primary" onClick={onButtonClick} className={`${styles.connectBtn} flex-none !mb-0`}>
            <GithubIcon />
            <span>{buttonText}</span>
            <ArrorIcon fill="#F9F9F9" />
          </Button>
        )}
        {extra}
      </div>
    );
  }

  return (
    <div className={styles.msgContainer}>
      {primaryIcon}
      <div className={styles.msgTitle}>
        {msgTitle}
      </div>
      {msgDesc && <div className={styles.msgDesc}>{msgDesc}</div>}
      {showButton && (
        <>
          <Button type="primary" onClick={onButtonClick} className={styles.connectBtn}>
            <GithubIcon />
            <span>{buttonText}</span>
            <ArrorIcon fill="#F9F9F9" />
          </Button>
          {extra}
          {/* <a href="/#" className={styles.link}>
            Connect another account
          </a> */}
        </>
      )}
    </div>
  );
};

export default MessageContainer;
